import React, { useState } from 'react';
import LoginButton from './LoginButton';
import LogoutButton from './LogoutButton';
import './styles/Widget.css';

const LoginPopup = (props) => {
	return (
		<div className="LoginPopup__container">
			<button className="LoginPopup__exitButton" onClick={props.handleClose}>
				x
			</button>
			<h3>Start Using Thumbs!</h3>
			<p>Uh oh! You have to be logged in to vote.</p>
			<LoginButton />
			<LogoutButton />

			{/* <a
					className="LoginDropdown__link"
					target="_blank"
					rel="noreferrer"
					href="https://anniepawl.github.io/Thumbs/"
				>
					More About Thumbs
				</a> */}
		</div>
	);
};

export default LoginPopup;
